import { useQuery } from "@tanstack/react-query"

import queries from "src/queries"
import mentorCloudService, { GetFolderRequest } from "src/service/mentor-cloud-service"

export const useMentorCloudFolders = (parentfolderId?: number, enabled = true) => {
  return useQuery({
    queryKey: parentfolderId ? queries.mentorCloud.folder(parentfolderId).queryKey : queries.mentorCloud.all.queryKey,
    queryFn: () => {
      const payload: GetFolderRequest = {
        order_by: [{ column: "created_at_epoch", ascending: true }]
      }

      if (parentfolderId) {
        payload.filter_by = [{
          attribute: 'parent_folder_id',
          operator: '==',
          value: parentfolderId
        }]
      } else {
        payload.filter_by = [{
          attribute: 'parent_folder_id',
          operator: 'is_null',
          value: true
        }]
      }

      return mentorCloudService.getFolder(payload)
    },
    select: response => response.data.result,
    enabled,
  })
}
